import computeCycleAndDateInfo from './computeCycleAndDateInfo';
import registry from "~/components/DoRegistry.js";

//Takes in a hot table and filters out empty rows, usually before sending to backend
function getNonBlankJSONRows(hotInstance){
    var gridData=hotInstance.getSourceData();
    var cleanedData=[];
    gridData.forEach(function(object, rowKey) {
        if (!hotInstance.isEmptyRow(rowKey)) cleanedData.push(object);
    });
    return cleanedData;
}

/**
 *
 * params hotInstance
 * function setDataInColumn that will set a value in columns
 */
 function setDataInColumnFn(hotInstance){
    /**
     * fills all cells in column with fill value
     */
    return function setDataInColumn(fillValue, columnName){
        if(!hotInstance){
            return;
        }
        var colNum=hotInstance.getColHeader().indexOf(columnName);
        if(colNum===-1){
            return;
        }
        var numRows=hotInstance.countRows();
        for(var i=0;i<numRows;i++){
            if(!hotInstance.isEmptyRow(i)) {
                hotInstance.setDataAtCell(i, colNum, fillValue + "");
            }
        }
        hotInstance.selectCell(0,colNum);
        hotInstance.render();
    }
 }
var fnObj={getNonBlankJSONRows,setDataInColumnFn}
registry.register(__filename, fnObj);
export {getNonBlankJSONRows,setDataInColumnFn, computeCycleAndDateInfo};